// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"2ae8bb89","433":"2eec70b8","453":"f48b6346"}[chunkId] + ".chunk.js";
};